import React from 'react';
import './CrewTimesheet.scss';
import {
    Alert,
    Button,
    Input,
    InputGroup,
    Label,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
} from 'reactstrap';
import moment from 'moment';
import { FormCheckbox } from '../common/forms/FormElements';
import { MomentTimeFormat } from '../MomentTimeFormat';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle, faUserSlash } from '@fortawesome/free-solid-svg-icons';
import { getTreatAsRemoved } from './TimesheetDetail';
import {
    addClientTimesheetContractPhaseAdjustmentSafe,
    getUpdatedJobTime,
} from './CrewTimesheet';
import _ from 'lodash-es';
import Select from 'react-select';
import AdjustmentDetail from './AdjustmentDetail';
import { fromUtcToLocalMoment } from '../utilities/DateHelpers';

export default class TimesheetDetailTimeModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            startTime: null,
            endTime: null,
            removed: null,
            absenceReasonId: null,
        };
    }

    getStartTime = () => {
        const { startTime } = this.state;

        if (startTime) {
            return startTime;
        }

        const { timesheetDetail } = this.props;

        const localStart = fromUtcToLocalMoment(
            timesheetDetail.adjustedStart ?? timesheetDetail.start
        );

        return localStart.format(MomentTimeFormat.TwentyFourHourWithLeading);
    };

    getPriorStartTime = () => {
        const { timesheetDetail } = this.props;

        const localStart = fromUtcToLocalMoment(timesheetDetail.start);

        return localStart.format(MomentTimeFormat.TwentyFourHourWithLeading);
    };

    getEndTime = () => {
        const { endTime } = this.state;

        if (endTime) {
            return endTime;
        }

        const { timesheetDetail } = this.props;

        const localEnd =
            (timesheetDetail.adjustedEnd ?? timesheetDetail.end)
                ? fromUtcToLocalMoment(
                      timesheetDetail.adjustedEnd ?? timesheetDetail.end
                  )
                : null;

        return localEnd
            ? localEnd.format(MomentTimeFormat.TwentyFourHourWithLeading)
            : null;
    };

    getPriorEndTime = () => {
        const { timesheetDetail } = this.props;

        const localEnd = timesheetDetail.end
            ? fromUtcToLocalMoment(timesheetDetail.end)
            : null;

        return localEnd
            ? localEnd.format(MomentTimeFormat.TwentyFourHourWithLeading)
            : null;
    };

    onChangeStartTime = (e) => {
        if (!e) {
            return;
        }

        const startTime = e.target.value;

        this.setState({ startTime });
    };

    onChangeEndTime = (e) => {
        if (!e) {
            return;
        }

        const endTime = e.target.value;

        this.setState({ endTime });
    };

    onChangeRemoved = (e) => {
        if (!e) {
            return;
        }

        let { absenceReasonId, startTime, endTime } = this.state;
        const { timesheetDetail, isAdmin } = this.props;

        const removed = e.target.checked;

        if (removed && !absenceReasonId) {
            absenceReasonId = isAdmin
                ? timesheetDetail.adjustedAbsenceReasonId
                : timesheetDetail.absenceReasonId;
        }

        if (!removed) {
            startTime = this.getStartTime();
            endTime = this.getEndTime();
        }

        this.setState({ removed, absenceReasonId, startTime, endTime });
    };

    onChangeDetailStartTime = (timesheet) => {
        const { startTime } = this.state;

        if (!startTime) {
            return;
        }

        const { isAdmin, timesheetDetail } = this.props;

        const updatedStartTime = getUpdatedJobTime(timesheet, startTime);

        const localTimesheetDetail = this.getLocalTimesheetDetail(
            timesheet,
            timesheetDetail
        );

        if (isAdmin) {
            localTimesheetDetail.adjustedStart = updatedStartTime;

            if (!localTimesheetDetail.adjustedEnd) {
                localTimesheetDetail.adjustedEnd = localTimesheetDetail.end;
            }
        } else {
            localTimesheetDetail.start = updatedStartTime;
        }
    };

    onChangeDetailEndTime = (timesheet) => {
        const { endTime } = this.state;

        if (!endTime) {
            return;
        }

        const { timesheetDetail, isAdmin } = this.props;

        const updatedEndTime = getUpdatedJobTime(timesheet, endTime);

        const localTimesheetDetail = this.getLocalTimesheetDetail(
            timesheet,
            timesheetDetail
        );

        if (isAdmin) {
            localTimesheetDetail.adjustedEnd = updatedEndTime;

            if (!localTimesheetDetail.adjustedStart) {
                localTimesheetDetail.adjustedStart = localTimesheetDetail.start;
            }
        } else {
            localTimesheetDetail.end = updatedEndTime;
        }
    };

    onDetailNotesChange = (dataContainer, e) => {
        if (!dataContainer || !e) {
            return;
        }

        const { timesheetDetailId } = dataContainer;
        const notes = e.target.value;

        const { timesheet, isAdmin, onTimesheetMutated } = this.props;

        timesheet.timesheetDetails.forEach((td) => {
            if (td.id != timesheetDetailId) {
                return;
            }

            if (isAdmin) {
                td.adjustmentNotes = notes;
            } else {
                td.notes = notes;
            }
        });

        onTimesheetMutated(timesheet);
    };

    addTimesheetDetailContractPhaseAdjustments = (timesheetDetail) => {
        if (
            !timesheetDetail ||
            !timesheetDetail.timesheetDetailContractPhases ||
            timesheetDetail.timesheetDetailContractPhaseAdjustments.length > 0
        ) {
            return;
        }

        const timesheetDetailContractPhaseAdjustments = _.clone(
            timesheetDetail.timesheetDetailContractPhases
        );

        timesheetDetailContractPhaseAdjustments.forEach((tdcpa) => {
            const timesheetDetailContractPhase =
                timesheetDetail.timesheetDetailContractPhases.find(
                    (tdcp) => tdcp.contractPhaseId == tdcpa.contractPhaseId
                );

            tdcpa.timesheetDetailContractPhaseId =
                timesheetDetailContractPhase?.id;

            tdcpa.id = 0;
        });

        timesheetDetail.timesheetDetailContractPhaseAdjustments =
            timesheetDetailContractPhaseAdjustments;
    };

    getLocalTimesheetDetail = (timesheet, timesheetDetail) =>
        timesheet.timesheetDetails.find((td) => td.id == timesheetDetail.id);

    onDetailRemovedChange = (timesheet) => {
        const { job, isAdmin, timesheetDetail } = this.props;

        const { removed, absenceReasonId } = this.state;

        if (removed == null) {
            return;
        }

        const localTimesheetDetail = this.getLocalTimesheetDetail(
            timesheet,
            timesheetDetail
        );

        if (isAdmin) {
            localTimesheetDetail.adjustedRemoved = removed;
            localTimesheetDetail.adjustedAbsenceReasonId = absenceReasonId;

            if (
                localTimesheetDetail.adjustedRemoved !=
                localTimesheetDetail.removed
            ) {
                this.addTimesheetDetailContractPhaseAdjustments(
                    localTimesheetDetail
                );

                localTimesheetDetail.timesheetDetailContractPhaseAdjustments.forEach(
                    (tdcpa) => {
                        let valueBefore = 0;

                        if (localTimesheetDetail.adjustedRemoved) {
                            valueBefore = tdcpa.quantity;
                            tdcpa.quantity = 0;
                        }

                        addClientTimesheetContractPhaseAdjustmentSafe(
                            timesheet,
                            job,
                            tdcpa.contractPhaseId
                        );

                        const timesheetContractPhaseAdjustment =
                            timesheet.timesheetContractPhaseAdjustments.find(
                                (tcpa) =>
                                    tcpa.contractPhaseId ==
                                    tdcpa.contractPhaseId
                            );

                        if (
                            timesheetContractPhaseAdjustment.timeSpent >=
                            valueBefore
                        ) {
                            timesheetContractPhaseAdjustment.timeSpent -=
                                Number(valueBefore);
                        }
                    }
                );
            }
        } else {
            localTimesheetDetail.removed = removed;
            localTimesheetDetail.absenceReasonId = absenceReasonId;

            if (localTimesheetDetail.removed) {
                localTimesheetDetail.timesheetDetailContractPhases.forEach(
                    (tdcp) => {
                        const timesheetContractPhase =
                            timesheet.timesheetContractPhases.find(
                                (tcp) =>
                                    tcp.contractPhaseId == tdcp.contractPhaseId
                            );

                        timesheetContractPhase.timeSpent -= Number(
                            tdcp.quantity
                        );

                        tdcp.quantity = 0;
                    }
                );
            }
        }
    };

    onUpdateComplete = () => {
        const { timesheet, onTimesheetMutated, toggleModal } = this.props;

        this.onChangeDetailStartTime(timesheet);
        this.onChangeDetailEndTime(timesheet);
        this.onDetailRemovedChange(timesheet);

        this.setState({
            startTime: null,
            endTime: null,
            removed: null,
            absenceReasonId: null,
        });

        onTimesheetMutated(timesheet);

        toggleModal();
    };

    onAbsenceReasonChange = (absenceReason) => {
        const absenceReasonId = absenceReason ? absenceReason.id : null;

        let { removed } = this.state;

        if (!removed && absenceReasonId) {
            removed = true;
        }

        this.setState({ absenceReasonId, removed });
    };

    isValid = () => {
        const { removed, absenceReasonId, startTime, endTime } = this.state;

        if (removed) {
            return Boolean(absenceReasonId);
        }

        if (startTime) {
            if (endTime) {
                return endTime > startTime;
            }

            return this.getEndTime() > startTime;
        }

        if (endTime) {
            if (startTime) {
                return endTime > startTime;
            }

            return endTime > this.getStartTime();
        }

        return false;
    };

    getUnderlyingAbsenceReason = () => {
        const { absenceReasons, timesheetDetail } = this.props;

        return absenceReasons.find(
            (ar) =>
                ((timesheetDetail.removed &&
                    timesheetDetail.adjustedRemoved === false) ||
                    (timesheetDetail.adjustedRemoved &&
                        timesheetDetail.absenceReasonId !=
                            timesheetDetail.adjustedAbsenceReasonId)) &&
                ar.id == timesheetDetail.absenceReasonId
        );
    };

    render() {
        const {
            timesheetDetail,
            showModal,
            toggleModal,
            headerText,
            isReadOnly,
            absenceReasons,
        } = this.props;

        const { removed, absenceReasonId } = this.state;

        if (!timesheetDetail) {
            return null;
        }

        const startTime = this.getStartTime();
        const endTime = this.getEndTime();

        const priorStartTime = this.getPriorStartTime();
        const priorEndTime = this.getPriorEndTime();

        const isRemoved = removed ?? getTreatAsRemoved(timesheetDetail);

        const selectedAbsenceReasonId = absenceReasonId
            ? absenceReasonId
            : (timesheetDetail.adjustedAbsenceReasonId ??
              timesheetDetail.absenceReasonId);

        const underlyingAbsenceReason = this.getUnderlyingAbsenceReason();

        const valid = this.isValid();

        return (
            <Modal isOpen={showModal} fade={false} autoFocus={false} size="xl">
                <ModalHeader toggle={toggleModal}>{headerText}</ModalHeader>
                <ModalBody>
                    <AdjustmentDetail
                        entity={timesheetDetail}
                        {...this.props}
                    />

                    {!isRemoved && (
                        <div className="d-flex">
                            <div className="col-6">
                                <Label for="start-time">Start Time</Label>
                                <Input
                                    id="start-time"
                                    type="time"
                                    step={900}
                                    value={startTime}
                                    onChange={this.onChangeStartTime}
                                    autoFocus={true}
                                    disabled={isReadOnly}
                                />
                            </div>

                            <div className="col-6">
                                <Label for="end-time">End Time</Label>
                                <Input
                                    id="end-time"
                                    type="time"
                                    step={900}
                                    value={endTime || ''}
                                    onChange={this.onChangeEndTime}
                                    disabled={isReadOnly}
                                />
                            </div>
                        </div>
                    )}

                    {!isRemoved &&
                        (timesheetDetail.adjustedStart ||
                            timesheetDetail.adjustedEnd) && (
                            <div className="d-flex">
                                <div className="col-6">
                                    <Label>Previous Start Time</Label>
                                    <Input
                                        type="time"
                                        value={priorStartTime}
                                        disabled={true}
                                    />
                                </div>

                                <div className="col-6">
                                    <Label>Previous End Time</Label>
                                    <Input
                                        type="time"
                                        value={priorEndTime || ''}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                        )}

                    <div className="d-flex mt-4">
                        <div className="col-6 my-auto">
                            <InputGroup>
                                <FormCheckbox
                                    labelText="Did Not Show"
                                    onChange={this.onChangeRemoved}
                                    checked={
                                        removed ??
                                        timesheetDetail.adjustedRemoved ??
                                        timesheetDetail.removed
                                    }
                                    disabled={isReadOnly}
                                />
                            </InputGroup>
                        </div>

                        {isRemoved && (
                            <div className="col-6">
                                <Label for="absenceReason">
                                    Absence Reason
                                </Label>

                                <Select
                                    id="absenceReason"
                                    options={absenceReasons}
                                    getOptionValue={(ar) => ar.id}
                                    getOptionLabel={(ar) => ar.name}
                                    onChange={this.onAbsenceReasonChange}
                                    value={absenceReasons.find(
                                        (ar) => ar.id == selectedAbsenceReasonId
                                    )}
                                />
                            </div>
                        )}
                    </div>

                    <div className="mt-3">
                        <Label for="notes">Notes</Label>
                        <Input
                            id="notes"
                            type="textarea"
                            value={
                                timesheetDetail.adjustmentNotes ??
                                timesheetDetail.notes
                            }
                            onChange={this.onDetailNotesChange.bind(this, {
                                timesheetDetailId: timesheetDetail.id,
                            })}
                            disabled={isReadOnly}
                        />

                        {timesheetDetail.adjustmentNotes &&
                            timesheetDetail.notes && (
                                <div>
                                    Here are the notes from the underlying
                                    timesheet.
                                    <pre>{timesheetDetail.notes}</pre>
                                </div>
                            )}
                    </div>

                    {timesheetDetail.adjustedRemoved &&
                        !timesheetDetail.removed && (
                            <Alert color="info" fade={false}>
                                <FontAwesomeIcon
                                    icon={faInfoCircle}
                                    className="mr-1"
                                />
                                On the original timesheet, start time was{' '}
                                {moment(timesheetDetail.start).format(
                                    MomentTimeFormat.AnteTwelveHour
                                )}{' '}
                                and end time was{' '}
                                {moment(timesheetDetail.end).format(
                                    MomentTimeFormat.AnteTwelveHour
                                )}
                                .
                            </Alert>
                        )}

                    {underlyingAbsenceReason && (
                        <Alert color="info" fade={false} className="mt-2">
                            <FontAwesomeIcon
                                icon={faUserSlash}
                                className="mr-1"
                            />
                            On the original timesheet, marked absent:{' '}
                            {underlyingAbsenceReason.name}.
                        </Alert>
                    )}
                </ModalBody>
                {!isReadOnly && (
                    <ModalFooter>
                        <Button
                            type="button"
                            color="success"
                            onClick={this.onUpdateComplete}
                            disabled={!valid}
                        >
                            Update
                        </Button>
                    </ModalFooter>
                )}
            </Modal>
        );
    }
}
